import { isPlatformBrowser } from '@angular/common';
import type { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  /**
   * Set auth token for all requests with the url starting with /api/authenticated.
   */
  const platformId = inject(PLATFORM_ID);

  if (isPlatformBrowser(platformId)) {
    const token = AuthService.getAuthToken();
    if (token && (req.url.startsWith('/api/authenticated') || req.url.startsWith(environment.strapiBaseUrl))) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    /**
     * Set base url for API calls in dev environment because the frontend and middleware must be started separately
     * on different ports.
     */
    if (req.url.startsWith('/api') && !environment.production) {
      req = req.clone({
        url: `${environment.apiBaseUrl}${req.url}`,
      });
    }
  }

  return next(req);
};
